<template lang="html">
  <section>
    <div>
      <div
        ref="topDropPoint"
        v-if="show.top"
        class="m-h_dropzone top"
        :class="{
          row: isTopRow,
          inner: isTopInner
        }"
        @drop.stop="onDropPoints($event, position.TOP)"
        @dragover.stop.prevent
        @dragenter.stop="onDropPointsEnter($event)"
        @dragleave.stop="onDropPointsLeave($event)"
      >
        <div></div>
      </div>
      <div
        ref="centerDropPoint"
        v-if="show.center"
        class="m-h_dropzone center"
        @drop.stop="onDropPoints($event, position.CENTER)"
        @dragover.stop.prevent
        @dragenter.stop="onDropPointsEnter($event)"
        @dragleave.stop="onDropPointsLeave($event)"
      >
        <div></div>
      </div>
      <div
        ref="bottomDropPoint"
        v-if="show.bottom"
        class="m-h_dropzone bottom"
        :class="{
          row: isBottomRow,
          hidden: isBottomHidden,
          inner: isBottomInner
        }"
        @drop.stop="onDropPoints($event, position.BOTTOM)"
        @dragover.stop.prevent
        @dragenter.stop="onDropPointsEnter($event)"
        @dragleave.stop="onDropPointsLeave($event)"
      >
        <div></div>
      </div>
      <div
        ref="leftDropPoint"
        v-if="show.left"
        class="m-v_dropzone left"
        :class="{
          column: isLeftColumn,
          inner: isLeftInner,
          section: isLeftSection,
          'main-inner': isLeftMainInner
        }"
        @drop.stop="onDropPoints($event, position.LEFT)"
        @dragover.stop.prevent
        @dragenter.stop="onDropPointsEnter($event)"
        @dragleave.stop="onDropPointsLeave($event)"
      >
        <div></div>
      </div>
      <div
        ref="rightDropPoint"
        v-if="show.right"
        class="m-v_dropzone right"
        :class="{
          column: isRightColumn,
          inner: isRightInner,
          'main-inner': isRightMainInner,
          hidden: isRightHidden
        }"
        @drop.stop="onDropPoints($event, position.RIGHT)"
        @dragover.stop.prevent
        @dragenter.stop="onDropPointsEnter($event)"
        @dragleave.stop="onDropPointsLeave($event)"
      >
        <div></div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { DROP_POSITION } from "@/views/drag-drop-pages/static/drop-position";
  import { LAYOUT_TYPE } from "@/views/drag-drop-pages/static/layout-type";
  export default  {
    name: "drop-points",
    props: {
      componentId: {
        type: String
      },
      parentLayoutId: {
        type: String
      },
      show: {
        type: Object,
        default: function () {
          return {
            center: false,
            top: false,
            bottom: false,
            left: false,
            right: false
          };
        }
      },
      data: {
        type: Object
      },
      isRoot: {
        type: Boolean
      },
      hasChildren: {
        type: Boolean
      }
    },
    computed: {
      isTopRow() {
        return this.data.layout === LAYOUT_TYPE.ROW;
      },
      isTopInner() {
        return (this.data.parentLayout === LAYOUT_TYPE.COLUMN && this.data.position > 0) ||
        (this.data.depth < 3 && this.data.parentLayout === LAYOUT_TYPE.COLUMN);
      },
      isBottomRow() {
        return this.data.layout === LAYOUT_TYPE.ROW;
      },
      isBottomHidden() {
        return this.data.parentLayout === LAYOUT_TYPE.COLUMN &&
        this.data.position > -1 &&
        this.data.position !== this.data.totalNodes - 1;
      },
      isBottomInner() {
        return this.data.depth < 3 &&
        this.data.layout === LAYOUT_TYPE.SECTION &&
        this.data.parentLayout === LAYOUT_TYPE.COLUMN &&
        this.data.totalNodes - 1;
      },
      isLeftColumn() {
        return this.data.layout === LAYOUT_TYPE.COLUMN;
      },
      isLeftInner() {
        return this.data.parentLayout === LAYOUT_TYPE.ROW &&
        this.data.position > 0;
      },
      isLeftSection() {
        return this.data.layout === LAYOUT_TYPE.SECTION &&
        this.data.position === 0;
      },
      isLeftMainInner() {
        return this.data.parentId === this.data.mainLayoutId;
      },
      isRightColumn() {
        return this.data.layout === LAYOUT_TYPE.COLUMN;
      },
      isRightInner() {
        return this.data.parentLayout === LAYOUT_TYPE.ROW &&
        this.data.position === this.data.totalNodes - 1;
      },
      isRightMainInner() {
        return this.data.parentId === this.data.mainLayoutId;
      },
      isRightHidden() {
        return this.data.parentLayout === LAYOUT_TYPE.ROW &&
        this.data.totalNodes > 1 &&
        this.data.position !== this.data.totalNodes - 1;
      }
    },
    mounted () {
      if(this.isRoot) {
        for(const [,ref] of Object.entries(this.$refs)) {
          ref.classList.add("m-root");
        }
      }
    },
    data () {
      return {
        position: DROP_POSITION
      }
    },
    methods: {
      onDropPoints(ev, position) {
        ev.preventDefault(); // for firefox so it does not shows image on page if draggable is not drop in a dropzone
        ev.target.classList.remove("m-dropzone_hover");
        this.$emit("on-drop-points", ev, {
          position,
          componentId: this.componentId,
          parentLayoutId: this.parentLayoutId
        });
      },
      onDropPointsEnter(ev) {
        ev.target.classList.add("m-dropzone_hover");
      },
      onDropPointsLeave(ev) {
        ev.target.classList.remove("m-dropzone_hover");
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  $line-background-color: #f3f3d3;
  $dropzone-background-color: floralwhite;
  $line-color: #ff9e16;
  $border: 2.5px dotted $line-color;
  $opacity: 0.6;

  .m-h_dropzone,
  .m-v_dropzone {
    position: absolute;
    box-sizing: border-box;
    border-radius: 25px;
    background-color: $dropzone-background-color;
  }

  .m-h_dropzone {
    width: 100%;
    height: 10px;
    & div {
      box-sizing: border-box;
    }
    &.top {
      padding: 5px 5px 5px;
      top: -7px;
      left: 0;
      & div {
        border-top: $border;
        background-color: $line-background-color;
        opacity: $opacity;
        width: 100%;
      }
      &.m-root {
        top: -22px;
      }
      &.row {
        top: -12px;
        left: 15px;
      }
      &.inner {
        top: -12px;
      }
    }

    &.center {
      padding: 5px 0 5px;
      top: 60%;
      left: 5%;
      max-width: 90%;
      & div {
        border-bottom: $border;
        background-color: $line-background-color;
        opacity: $opacity;
        width: 100%;
      }
      &.m-root {
        top: 20%;
      }
    }

    &.bottom {
      padding: 5px 5px 5px;
      bottom: -3px;
      left: 0;
      & div {
        border-bottom: $border;
        background-color: $line-background-color;
        opacity: $opacity;
        width: 100%;
      }
      &.inner {
        bottom: -12px;
      }
      &.m-root {
        bottom: -18px;
        padding: 5px 5px 0;
      }
      &.row {
        bottom: -9px;
        left: 15px;
      }
    }
  }

  .m-v_dropzone {
    width: 10px;
    height: 100%;
    & div {
      box-sizing: border-box;
      height: 100%;
    }
    &.left {
      top: 0;
      left: -8px;
      padding: 5px 5px 5px 5px;
      & div {
        border-left: $border;
        background-color: $line-background-color;
        opacity: $opacity;
        height: 100%;
      }
      &.m-root {
        left: -28px;
        padding: 5px 8px 5px 10px;
      }
      &.inner {
        left: -13px;
        &.section {
          left: -8px;
        }
      }
      &.column {
        left: -12px;
        &.main-inner {
          left: -16px;
        }
      }
    }
    &.right {
      top: 0;
      right: -4px;
      padding: 5px 5px 5px 5px;
      & div {
        border-right: $border;
        background-color: $line-background-color;
        opacity: $opacity;
        height: 100%;
      }
      &.m-root {
        right: -18px;
        padding: 10px 10px 10px 8px;
      }
      &.column {
        right: -10px;
        &.inner {
          right: -8px;
        }
        &.main-inner {
          right: -15px;
        }
      }
    }
  }

  .m-dropzone_hover,
  .m-h_dropzone:hover,
  .m-v_dropzone:hover {
    background-color: $line-color;
    z-index: 20;
  }
  .hidden {
    display: none;
  }
</style>
